module.exports = __webpack_public_path__ + "static/career-786a641141a74b68bdc1bf0ff34826fc.jpg";